import React, { Component } from 'react';
import { ControlLabel, FormControl, FormGroup, Col } from 'react-bootstrap';
import Recaptcha from "react-recaptcha";
import Select from 'react-select';

export class MakeReservation extends Component {
  displayName = MakeReservation.name

  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      addressLine1: '',
      addressLine2: '',
      postalCode: '',
      city: '',
      country: '',
      internal_country: '',
      email: '',
      phone: '',
      remarks: '',
      captchaOk: false
    };

    this.countries = Object.keys(this.props.localizations)
      .filter(key => key.substring(0, 8) === 'Country_')
      .map(key => ({ value: key.substring(8), label: this.props.localizations[key] }))
      .sort((option1, option2) => (option1.label > option2.label) ? 1 : -1);
  }

  isFormComplete() {
    let formComplete =
      this.state.captchaOk &&
      this.state.firstName !== '' &&
      this.state.lastName !== '' &&
      this.state.addressLine1 !== '' &&
      this.state.city !== '' &&
      this.state.country !== '' &&
      this.state.phone !== '' &&
      this.state.email !== '';

    if (formComplete && this.props.onFormComplete !== undefined) {
      this.props.onFormComplete(this.state);
    }
    if (!formComplete && this.props.onFormIncomplete !== undefined) {
      this.props.onFormIncomplete();
    }
  }

  handleChange(event) {
    let field = {};
    field[event.target.name] = event.target.value;
    this.setState(field, this.isFormComplete);
  }

  handleSelectedCountryChange(selectedCountry) {    
    let field = {};
    field["country"] = `${selectedCountry.label} (${selectedCountry.value})`;
    field["internal_country"] = selectedCountry;
    this.setState(field, this.isFormComplete);
  }

  onCaptchaVerified(value) {
    if (value !== undefined && value !== null) {
      this.setState({ captchaOk: true }, this.isFormComplete);
    }
  }

  
  render() {
    return (
      <div>
        <ControlLabel>{this.props.localizations.Name}</ControlLabel>
        <FormGroup>
          <Col xs={6}>
            <FormControl
              name="firstName"
              type="text"
              value={this.state.firstName}
              placeholder={this.props.localizations.FirstName + "*"}
              onChange={this.handleChange.bind(this)}
            />
          </Col>
          <Col xs={6}>
            <FormControl
              name="lastName"
              type="text"
              value={this.state.lastName}
              placeholder={this.props.localizations.LastName + "*"}
              onChange={this.handleChange.bind(this)}
            />
          </Col>
        </FormGroup>
        <ControlLabel>{this.props.localizations.Address}</ControlLabel>
        <FormControl
          name="addressLine1"
          type="text"
          value={this.state.addressLine1}
          placeholder={this.props.localizations.Address + "*"}
          onChange={this.handleChange.bind(this)}
        />
        <FormControl
          name="addressLine2"
          type="text"
          value={this.state.addressLine2}
          placeholder={this.props.localizations.AddressLine2}
          onChange={this.handleChange.bind(this)}
        />
        <FormGroup>
          <Col xs={4}>
            <FormControl
              name="postalCode"
              type="text"
              value={this.state.postalCode}
              placeholder={this.props.localizations.PostalCode}
              onChange={this.handleChange.bind(this)}
            />
          </Col>
          <Col xs={8}>
            <FormControl
              name="city"
              type="text"
              value={this.state.city}
              placeholder={this.props.localizations.City + "*"}
              onChange={this.handleChange.bind(this)}
            />
          </Col>
        </FormGroup>
        <Select isSearchable options={this.countries} onChange={selectedItem => this.handleSelectedCountryChange(selectedItem)} value={this.state.internal_country} placeholder={this.props.localizations.Country + "*"} />
        <ControlLabel>{this.props.localizations.ContactInformation}</ControlLabel>
        <FormGroup>
          <Col xs={4}>
            <FormControl
              name="phone"
              type="tel"
              value={this.state.phone}
              placeholder={this.props.localizations.TelephoneNumber + "*"}
              onChange={this.handleChange.bind(this)}
            />
          </Col>
          <Col xs={8}>
            <FormControl
              name="email"
              type="email"
              value={this.state.email}
              placeholder={this.props.localizations.Email + "*"}
              onChange={this.handleChange.bind(this)}
            />
          </Col>
        </FormGroup>
        <FormControl
          name="remarks"
          componentClass="textarea"
          value={this.state.remarks}
          placeholder={this.props.localizations.Remarks}
          onChange={this.handleChange.bind(this)}
        />
        <p>* {this.props.localizations.RequiredField}</p>
        <Recaptcha
          sitekey="6Lej0owUAAAAAN2LIYfgDO5B1WtBEeHq7rsYz0bf"
          verifyCallback={result => this.onCaptchaVerified(result)}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/MakeReservation.js